// import React, { useState } from 'react';
// import { Link } from 'react-router-dom';
// import officeimg1 from "../Assets/office1.jpg"
// import officeimg2 from "../Assets/office2.jpg"
// import officeimg3 from "../Assets/office3.jpg"
// import officeimg4 from "../Assets/office4.jpg"
// import officeimg5 from "../Assets/office5.jpg"
// import officeimg6 from "../Assets/office6.jpg"
// import bedimg1 from "../Assets/bed1.jpg"
// import bedimg2 from "../Assets/bed2.jpg"
// import bedimg3 from "../Assets/bed3.jpg"
// import bedimg4 from "../Assets/bed4.jpg"
// import bedimg5 from "../Assets/bed5.jpg"
// import bedimg6 from "../Assets/bed6.jpg"
// import bedimg7 from "../Assets/bed7.jpg"
// import livingroom1 from "../Assets/lr1.jpg"
// import livingroom2 from "../Assets/lr2.jpg"
// import livingroom3 from "../Assets/lr3.jpg"
// import livingroom4 from "../Assets/lr4.jpg"
// import livingroom5 from "../Assets/lr5.jpg"
// import livingroom6 from "../Assets/lr6.jpg"
// import livingroom7 from "../Assets/lr7.jpg"
// import temp1 from "../Assets/temple1.jpg"
// import kitchen1 from "../Assets/kitchen1.jpg"
// import kitchen2 from "../Assets/kitchen2.jpg"
// import kitchen3 from "../Assets/kitchen3.jpg"
// import kitchen4 from "../Assets/kitchen4.jpg"
// import dt1 from "../Assets/dt1.mp4"




// const Projects = () => {
//     const [activeCategory, setActiveCategory] = useState('All');
//     const [hoveredCard, setHoveredCard] = useState(null);

//     // Lightbox Album Overlay States
//     const [lightboxOpen, setLightboxOpen] = useState(false);
//     const [currentAlbum, setCurrentAlbum] = useState([]);
//     const [currentImgIdx, setCurrentImgIdx] = useState(0);
//     const [activeTitle, setActiveTitle] = useState('');

//     // Studio Categories
//     const categories = ['All', 'Residential', 'Commercial', 'Minimalist'];

//     // Updated Dataset with custom sub-image album arrays matching your structure
//     const projectsData = [
//         // {
//         //     id: 1,
//         //     title: 'The Linen Lounge',
//         //     category: 'Commercial',
//         //     size: '2,400 sqft',
//         //     img: 'unsplash.com',
//         //     gridSpan: 'large',
//         //     album: ['unsplash.com', 'unsplash.com']
//         // },
//         {
//             id: 2,
//             title: 'Dinner Table',
//             category: 'Residential',
//             size: 'Bespoke Item',
//             img: 'dt1', // Cover image placeholder for fallback/grid view
//             gridSpan: 'large',
//             type: 'video', // 1. ADD THIS INDICATOR KEY
//             // 2. PASTE YOUR MP4 VIDEO STREAM DIRECTLY INSIDE THE ALBUM ARRAY
//             album: [
//                 dt1,

//             ]
//         },
//         {
//             id: 3,
//             title: 'kitchen',
//             category: 'Residential',
//             // size: '1,800 sqft',
//             img: kitchen3,
//             gridSpan: 'small',
//             album: [kitchen3, kitchen2, kitchen4, kitchen1,]
//         },
//         {
//             id: 4,
//             title: 'Living room',
//             category: 'Commercial',
//             size: '1,500 sqft',
//             img: livingroom5,
//             gridSpan: 'tall',
//             album: [livingroom5, livingroom6, livingroom7, livingroom4, livingroom1, livingroom2, livingroom3]
//         },
//         {
//             id: 5,
//             title: 'Pooja room',
//             category: 'Minimalist',
//             // size: '3,200 sqft',
//             img: temp1,
//             gridSpan: 'small',
//             album: [temp1]
//         },
//         {
//             id: 6,
//             title: 'Bedroom',
//             category: 'Residential',
//             size: '1,200 sqft',
//             img: bedimg5,
//             gridSpan: 'large',
//             album: [bedimg1, bedimg2, bedimg3, bedimg4, bedimg5, bedimg6, bedimg7,]
//         },
//         {
//             id: 7,
//             title: 'Offices',
//             category: 'Commercial',
//             size: '440Sqft',
//             img: officeimg1,
//             gridSpan: 'small',
//             // Uses your local image reference along with layout options for inside your popup view
//             album: [officeimg1, officeimg2, officeimg3, officeimg4, officeimg5, officeimg6]
//         }
//     ];

//     // Trigger Album Lightbox Window Layer Setup
//     const openAlbum = (project) => {
//         setCurrentAlbum(project.album || [project.img]);
//         setCurrentImgIdx(0);
//         setActiveTitle(project.title);
//         setLightboxOpen(true);
//     };

//     const nextImage = (e) => {
//         e.stopPropagation(); // Stops parent container click collapse bubble
//         setCurrentImgIdx((prev) => (prev + 1) % currentAlbum.length);
//     };

//     const prevImage = (e) => {
//         e.stopPropagation();
//         setCurrentImgIdx((prev) => (prev - 1 + currentAlbum.length) % currentAlbum.length);
//     };

//     // Filtering Logic
//     const filteredProjects = activeCategory === 'All'
//         ? projectsData
//         : projectsData.filter(project => project.category === activeCategory);

//     // Premium Pastel Architectural Theme Context
//     const theme = {
//         background: '#F8F6F2',
//         surface: '#FFFFFF',
//         accent: '#D4AF37',
//         textMain: '#2C302E',
//         textMuted: '#7A827E',
//         border: 'rgba(44, 48, 46, 0.08)'
//     };

//     // Luxury CSS Framework Animations
//     const inlineAnimations = `
//     @keyframes scaleUpIn {
//       from { opacity: 0; transform: scale(0.92) translateY(30px); }
//       to { opacity: 1; transform: scale(1) translateY(0); }
//     }
//     .animate-portfolio-grid {
//       animation: scaleUpIn 0.8s cubic-bezier(0.16, 1, 0.3, 1) forwards;
//     }
//   `;

//     return (
//         <div style={{
//             background: theme.background,
//             minHeight: '100vh',
//             color: theme.textMain,
//             padding: '40px 60px',
//             fontFamily: 'system-ui, -apple-system, sans-serif',
//             boxSizing: 'border-box',
//             transition: 'background 0.5s ease'
//         }}>
//             <style>{inlineAnimations}</style>

//             {/* Navigation Return Hook */}
//             {/* <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '30px' }}>
//                 <Link
//                     to="/"
//                     style={{ color: theme.textMuted, textDecoration: 'none', fontSize: '0.9rem', letterSpacing: '1px', transition: 'color 0.2s' }}
//                     onMouseEnter={(e) => e.target.style.color = theme.accent}
//                     onMouseLeave={(e) => e.target.style.color = theme.textMuted}
//                 >
//                     ← Back To Main Screen
//                 </Link>
//                 <span style={{ fontSize: '0.8rem', color: theme.textMuted, letterSpacing: '2px', textTransform: 'uppercase' }}>
//                     ST Interior Studio
//                 </span>
//             </div> */}

//             {/* ==================== SCREEN TITLE & DYNAMIC FILTER BAR ==================== */}
//             <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', flexWrap: 'wrap', gap: '30px', marginBottom: '50px' }}>
//                 <div>
//                     <span style={{ color: theme.accent, textTransform: 'uppercase', letterSpacing: '4px', fontSize: '0.85rem', fontWeight: '600' }}>Exquisite Spaces</span>
//                     <h1 style={{ fontSize: '3.2rem', fontWeight: '300', margin: '5px 0 0 0', letterSpacing: '1px', color: theme.textMain }}>Selected Blueprints</h1>
//                 </div>

//                 {/* Filter Pill Architecture */}
//                 <div style={{ display: 'flex', gap: '12px', background: theme.surface, padding: '6px', borderRadius: '40px', border: `1px solid ${theme.border}`, boxShadow: '0 4px 10px rgba(0,0,0,0.02)' }}>
//                     {categories.map((cat) => {
//                         const isSelected = activeCategory === cat;
//                         return (
//                             <button
//                                 key={cat}
//                                 onClick={() => setActiveCategory(cat)}
//                                 style={{
//                                     background: isSelected ? theme.accent : 'transparent',
//                                     color: isSelected ? '#FFFFFF' : theme.textMain,
//                                     border: 'none',
//                                     padding: '10px 24px',
//                                     borderRadius: '30px',
//                                     fontSize: '0.9rem',
//                                     fontWeight: '600',
//                                     cursor: 'pointer',
//                                     transition: 'all 0.4s cubic-bezier(0.16, 1, 0.3, 1)',
//                                     letterSpacing: '0.5px'
//                                 }}
//                             >
//                                 {cat}
//                             </button>
//                         );
//                     })}
//                 </div>
//             </div>

//             {/* ==================== ASYMMETRIC LUXURY GRID SYSTEM ==================== */}
//             <div className="animate-portfolio-grid"
//                 style={{
//                     display: 'grid',
//                     gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))',
//                     gridAutoRows: '260px',
//                     gap: '30px',
//                     gridAutoFlow: 'dense'
//                 }}>
//                 {filteredProjects.map((project) => {
//                     const isCardHovered = hoveredCard === project.id;

//                     let gridStyle = {};
//                     if (project.gridSpan === 'large') gridStyle = { gridColumn: 'span 2', gridRow: 'span 2' };
//                     if (project.gridSpan === 'tall') gridStyle = { gridRow: 'span 2' };

//                     return (
//                         <div
//                             key={project.id}
//                             onClick={() => openAlbum(project)} // Launch popup modal on select
//                             onMouseEnter={() => setHoveredCard(project.id)}
//                             onMouseLeave={() => setHoveredCard(null)}
//                             style={{
//                                 ...gridStyle,
//                                 position: 'relative',
//                                 borderRadius: '20px',
//                                 overflow: 'hidden',
//                                 background: theme.surface,
//                                 border: `1px solid ${theme.border}`,
//                                 cursor: 'pointer',
//                                 boxShadow: isCardHovered ? '0 15px 35px rgba(44, 48, 46, 0.08)' : 'none',
//                                 transform: isCardHovered ? 'translateY(-6px)' : 'translateY(0)',
//                                 transition: 'all 0.5s cubic-bezier(0.16, 1, 0.3, 1)'
//                             }}
//                         >
//                             {/* Portfolio Structural Image Layer */}
//                             {/* <img
//                                 src={project.img}
//                                 alt={project.title}
//                                 style={{
//                                     width: '100%',
//                                     height: '100%',
//                                     objectFit: 'cover',
//                                     opacity: isCardHovered ? 0.85 : 0.95,
//                                     transform: isCardHovered ? 'scale(1.04)' : 'scale(1)',
//                                     transition: 'all 0.6s cubic-bezier(0.16, 1, 0.3, 1)'
//                                 }}
//                             /> */}
//                             {/* Replace the current <img /> line inside filteredProjects.map with this block */}
//                             {project.type === 'video' ? (
//                                 <video
//                                     autoPlay
//                                     loop
//                                     muted
//                                     playsInline
//                                     style={{
//                                         width: '100%',
//                                         height: '100%',
//                                         objectFit: 'cover',
//                                         opacity: isCardHovered ? 0.85 : 0.95,
//                                         transform: isCardHovered ? 'scale(1.04)' : 'scale(1)',
//                                         transition: 'all 0.6s cubic-bezier(0.16, 1, 0.3, 1)'
//                                     }}
//                                 >
//                                     {/* Grabs first index video file link out of album configuration */}
//                                     <source src={project.album[0]} type="video/mp4" />
//                                 </video>
//                             ) : (
//                                 <img
//                                     src={project.img}
//                                     alt={project.title}
//                                     style={{
//                                         width: '100%',
//                                         height: '100%',
//                                         objectFit: 'cover',
//                                         opacity: isCardHovered ? 0.85 : 0.95,
//                                         transform: isCardHovered ? 'scale(1.04)' : 'scale(1)',
//                                         transition: 'all 0.6s cubic-bezier(0.16, 1, 0.3, 1)'
//                                     }}
//                                 />
//                             )}

//                             {/* Soft Gradient Overlay for Light Interface Readability */}
//                             <div style={{
//                                 position: 'absolute',
//                                 top: 0,
//                                 left: 0,
//                                 width: '100%',
//                                 height: '100%',
//                                 background: 'linear-gradient(to top, rgba(248, 246, 242, 0.95) 0%, rgba(248, 246, 242, 0.1) 60%)',
//                                 zIndex: 2,
//                                 opacity: isCardHovered ? 0.9 : 0.8,
//                                 transition: 'opacity 0.4s ease'
//                             }} />

//                             {/* Text Content Overlay Layer */}
//                             <div style={{
//                                 position: 'absolute',
//                                 bottom: 0,
//                                 left: 0,
//                                 width: '100%',
//                                 padding: '30px',
//                                 boxSizing: 'border-box',
//                                 zIndex: 3,
//                                 transform: isCardHovered ? 'translateY(-4px)' : 'translateY(0)',
//                                 transition: 'transform 0.4s cubic-bezier(0.16, 1, 0.3, 1)'
//                             }}>
//                                 <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
//                                     <span style={{
//                                         fontSize: '0.75rem',
//                                         color: theme.accent,
//                                         textTransform: 'uppercase',
//                                         letterSpacing: '2px',
//                                         fontWeight: '600'
//                                     }}>
//                                         {project.category}
//                                     </span>
//                                     <span style={{ fontSize: '0.8rem', color: theme.textMuted }}>
//                                         {project.size}
//                                     </span>
//                                 </div>

//                                 <h3 style={{
//                                     margin: '0',
//                                     fontSize: project.gridSpan === 'large' ? '1.8rem' : '1.3rem',
//                                     fontWeight: '400',
//                                     letterSpacing: '0.5px',
//                                     color: theme.textMain
//                                 }}>
//                                     {project.title}
//                                 </h3>

//                                 {/* Micro-Interaction Accent Line */}
//                                 <div style={{
//                                     height: '2px',
//                                     background: theme.accent,
//                                     marginTop: '12px',
//                                     width: isCardHovered ? '100%' : '0%',
//                                     transition: 'width 0.4s ease'
//                                 }} />
//                             </div>

//                         </div>
//                     );
//                 })}
//             </div>

//             {/* ==================== INTERACTIVE IMAGE ALBUM LIGHTBOX POPUP ==================== */}
//             {lightboxOpen && (
//                 <div
//                     onClick={() => setLightboxOpen(false)} // Click dark background margin edges to close popup
//                     style={{
//                         position: 'fixed',
//                         top: 0,
//                         left: 0,
//                         width: '100vw',
//                         height: '100vh',
//                         background: 'rgba(26, 28, 27, 0.96)',
//                         zIndex: 100,
//                         display: 'flex',
//                         flexDirection: 'column',
//                         justifyContent: 'center',
//                         alignItems: 'center',
//                         backdropFilter: 'blur(10px)'
//                     }}
//                 >
//                     {/* Album Info Headers */}
//                     <div style={{ position: 'absolute', top: '30px', left: '40px', color: '#FFF' }}>
//                         <h4 style={{ margin: 0, fontSize: '1.4rem', fontWeight: 300, letterSpacing: '1px' }}>{activeTitle}</h4>
//                         <p style={{ margin: '5px 0 0 0', fontSize: '0.85rem', color: '#AAA' }}>Image {currentImgIdx + 1} of {currentAlbum.length}</p>
//                     </div>

//                     {/* Exit Button */}
//                     <button
//                         onClick={() => setLightboxOpen(false)}
//                         style={{
//                             position: 'absolute',
//                             top: '30px',
//                             right: '40px',
//                             background: 'none',
//                             border: 'none',
//                             color: '#FFF',
//                             fontSize: '2rem',
//                             cursor: 'pointer',
//                             opacity: 0.7,
//                             transition: 'opacity 0.2s'
//                         }}
//                         onMouseEnter={(e) => e.target.style.opacity = 1}
//                         onMouseLeave={(e) => e.target.style.opacity = 0.7}
//                     >
//                         ✕
//                     </button>

//                     {/* Main Image Slider Node Container */}
//                     <div style={{ display: 'flex', alignItems: 'center', gap: '40px', width: '85vw', justifyContent: 'space-between' }}>

//                         {/* LEFT VECTOR NAVIGATION ARROW */}
//                         <button
//                             onClick={prevImage}
//                             style={{
//                                 background: 'rgba(255,255,255,0.04)',
//                                 border: '1px solid rgba(255,255,255,0.1)',
//                                 color: '#FFF',
//                                 width: '60px',
//                                 height: '60px',
//                                 borderRadius: '50%',
//                                 fontSize: '1.5rem',
//                                 cursor: 'pointer',
//                                 transition: 'all 0.2s'
//                             }}
//                             onMouseEnter={(e) => { e.target.style.background = theme.accent; e.target.style.color = '#000'; }}
//                             onMouseLeave={(e) => { e.target.style.background = 'rgba(255,255,255,0.04)'; e.target.style.color = '#FFF'; }}
//                         >
//                             ‹
//                         </button>

//                         {/* DISPLAY RENDERED CORE IMAGE CONTAINER */}
//                         {/* <div style={{
//                             maxWidth: '70vw',
//                             maxHeight: '75vh',
//                             borderRadius: '12px',
//                             overflow: 'hidden',
//                             boxShadow: '0 30px 60px rgba(0,0,0,0.5)',
//                             background: '#000',
//                             display: 'flex',
//                             alignItems: 'center'
//                         }}>
//                             <img
//                                 src={currentAlbum[currentImgIdx]}
//                                 alt="Studio Interior Content Gallery"
//                                 onClick={(e) => e.stopPropagation()} // Protection boundary to keep popup from snapping shut when image body is selected
//                                 style={{
//                                     maxWidth: '100%',
//                                     maxHeight: '75vh',
//                                     objectFit: 'contain',
//                                     animation: 'scaleUpIn 0.4s ease-out'
//                                 }}
//                             />
//                         </div> */}
//                         {/* ==================== DISPLAY RENDERED CORE MEDIA CONTAINER ==================== */}
//                         <div style={{
//                             maxWidth: '70vw',
//                             maxHeight: '75vh',
//                             borderRadius: '12px',
//                             overflow: 'hidden',
//                             boxShadow: '0 30px 60px rgba(0,0,0,0.5)',
//                             background: '#000',
//                             display: 'flex',
//                             alignItems: 'center'
//                         }}>
//                             {/* Dynamic Track Identification: Checks if the path includes a video file extension or format indicators */}
//                             {currentAlbum[currentImgIdx]?.endsWith('.mp4') || currentAlbum[currentImgIdx]?.includes('video') ? (
//                                 <video
//                                     // CRITICAL FIX: The dynamic key parameter forces React to fully re-render the player on item slide changes
//                                     key={currentImgIdx}
//                                     autoPlay
//                                     controls // Adds default track scrubbers, full-screen options, and audio level configurations
//                                     loop
//                                     muted // Muted property guarantees cross-browser autoplay permissions
//                                     playsInline
//                                     onClick={(e) => e.stopPropagation()} // Prevents parent window from collapsing
//                                     style={{
//                                         maxWidth: '100%',
//                                         maxHeight: '75vh',
//                                         objectFit: 'contain'
//                                     }}
//                                 >
//                                     {/* Direct src mapping on the video tag itself fixes dynamic source update limitations */}
//                                     <source src={currentAlbum[currentImgIdx]} type="video/mp4" />
//                                     Your browser does not support the video tag.
//                                 </video>
//                             ) : (
//                                 <img
//                                     src={currentAlbum[currentImgIdx]}
//                                     alt="Studio Interior Content Gallery"
//                                     onClick={(e) => e.stopPropagation()}
//                                     style={{
//                                         maxWidth: '100%',
//                                         maxHeight: '75vh',
//                                         objectFit: 'contain',
//                                         animation: 'scaleUpIn 0.4s ease-out'
//                                     }}
//                                 />
//                             )}
//                         </div>

//                         {/* RIGHT VECTOR NAVIGATION ARROW */}
//                         <button
//                             onClick={nextImage}
//                             style={{
//                                 background: 'rgba(255,255,255,0.04)',
//                                 border: '1px solid rgba(255,255,255,0.1)',
//                                 color: '#FFF',
//                                 width: '60px',
//                                 height: '60px',
//                                 borderRadius: '50%',
//                                 fontSize: '1.5rem',
//                                 cursor: 'pointer',
//                                 transition: 'all 0.2s'
//                             }}
//                             onMouseEnter={(e) => { e.target.style.background = theme.accent; e.target.style.color = '#000'; }}
//                             onMouseLeave={(e) => { e.target.style.background = 'rgba(255,255,255,0.04)'; e.target.style.color = '#FFF'; }}
//                         >
//                             ›
//                         </button>
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// };

// export default Projects;


// import React, { useState } from 'react';
// import { Link } from 'react-router-dom';
// import officeimg1 from "../Assets/office1.jpg"
// import officeimg2 from "../Assets/office2.jpg"
// import officeimg3 from "../Assets/office3.jpg"
// import officeimg4 from "../Assets/office4.jpg"
// import officeimg5 from "../Assets/office5.jpg"
// import officeimg6 from "../Assets/office6.jpg"
// import officeimg7 from "../Assets/slider/office7.jpg"
// import officeimg8 from "../Assets/slider/office8.jpg"
// import officeimg9 from "../Assets/slider/office9.jpg"
// import officeimg10 from "../Assets/slider/office10.jpg"
// import officeimg11 from "../Assets/slider/1.jpg"


// import bedimg1 from "../Assets/bed1.jpg"
// import bedimg2 from "../Assets/bed2.jpg"
// import bedimg3 from "../Assets/bed3.jpg"
// import bedimg4 from "../Assets/bed4.jpg"
// import bedimg5 from "../Assets/bed5.jpg"
// import bedimg6 from "../Assets/bed6.jpg"
// import bedimg7 from "../Assets/bed7.jpg"
// import bedimg8 from "../Assets/bed8.jpg"
// import bedimg9 from "../Assets/bed9.jpg"


// import livingroom1 from "../Assets/lr1.jpg"
// import livingroom2 from "../Assets/lr2.jpg"
// import livingroom3 from "../Assets/lr3.jpg"
// import livingroom4 from "../Assets/lr4.jpg"
// import livingroom5 from "../Assets/lr5.jpg"
// import livingroom6 from "../Assets/lr6.jpg"
// import livingroom7 from "../Assets/lr7.jpg"

// import temp1 from "../Assets/temple1.jpg"
// import temp2 from "../Assets/slider/Minimalist2.jpg"
// import temp3 from "../Assets/slider/Minimalist3.jpg"
// import temp4 from "../Assets/slider/Minimalist4.jpg"
// import temp5 from "../Assets/slider/Minimalist5.jpg"
// import temp6 from "../Assets/slider/Minimalist6.jpg"
// import temp7 from "../Assets/slider/Minimalist7.jpg"
// import temp8 from "../Assets/slider/Minimalist8.jpg"
// import temp9 from "../Assets/slider/Minimalist9.jpg"
// import temp10 from "../Assets/slider/Minimalist10.jpg"



// import kitchen1 from "../Assets/kitchen1.jpg"
// import kitchen2 from "../Assets/slider/kitchen5.jpg"
// import kitchen3 from "../Assets/slider/kitchen6.jpg"
// import kitchen4 from "../Assets/kitchen4.jpg"
// import kitchen7 from "../Assets/slider/newkitchen1.jpg"
// import kitchen8 from "../Assets/slider/newkitchen2.jpg"

// import dt1 from "../Assets/dt1.mp4"

// const Projects = () => {
//     const [activeCategory, setActiveCategory] = useState('All');
//     const [hoveredCard, setHoveredCard] = useState(null);

//     // Lightbox Album Overlay States
//     const [lightboxOpen, setLightboxOpen] = useState(false);
//     const [currentAlbum, setCurrentAlbum] = useState([]);
//     const [currentImgIdx, setCurrentImgIdx] = useState(0);
//     const [activeTitle, setActiveTitle] = useState('');

//     // Studio Categories
//     const categories = ['All', 'Residential', 'Commercial', 'Minimalist'];

//     // Dataset Mapping
//     const projectsData = [
//         // {
//         //     id: 2,
//         //     title: 'Dinner Table',
//         //     category: 'Residential',
//         //     size: 'Bespoke Item',
//         //     img: dt1, 
//         //     gridSpan: 'large',
//         //     type: 'video', 
//         //     album: [dt1]
//         // },
//         {
//             id: 3,
//             title: 'Kitchen',
//             category: 'Residential',
//             img: kitchen3,
//             gridSpan: 'small',
//             album: [kitchen1,kitchen4,kitchen3, kitchen2,kitchen7,kitchen8 ]
//         },
//         {
//             id: 4,
//             title: 'Living Room',
//             category: 'Residential',
//             size: '1,500 sqft',
//             img: livingroom5,
//             gridSpan: 'tall',
//             album: [livingroom5, livingroom6, livingroom7, livingroom4,livingroom3, livingroom1, livingroom2, ]
//         },
//         {
//             id: 5,
//             title: 'Minimalist',
//             category: 'Minimalist',
//             img: temp1,
//             gridSpan: 'small',
//             album: [temp1,temp2,temp3,temp4,temp5,temp6,temp7,temp8,temp9,temp10]
//         },
//         {
//             id: 6,
//             title: 'Bedroom',
//             category: 'Residential',
//             size: '1,200 sqft',
//             img: bedimg5,
//             gridSpan: 'small',
//             album: [bedimg3,bedimg1, bedimg2, bedimg4, bedimg6,bedimg5,bedimg7,bedimg8,bedimg9]
//         },
//         {
//             id: 7,
//             title: 'Offices',
//             category: 'Commercial',
//             size: '440Sqft',
//             img: officeimg1,
//             gridSpan: 'small',
//             album: [officeimg1, officeimg2, officeimg3, officeimg4, officeimg5, officeimg6,officeimg11,officeimg7,officeimg8,officeimg9,officeimg10]
//         }
//     ];

//     // Trigger Album Lightbox Window Layer Setup
//     const openAlbum = (project) => {
//         setCurrentAlbum(project.album || [project.img]);
//         setCurrentImgIdx(0);
//         setActiveTitle(project.title);
//         setLightboxOpen(true);
//     };

//     const nextImage = (e) => {
//         e.stopPropagation(); 
//         setCurrentImgIdx((prev) => (prev + 1) % currentAlbum.length);
//     };

//     const prevImage = (e) => {
//         e.stopPropagation();
//         setCurrentImgIdx((prev) => (prev - 1 + currentAlbum.length) % currentAlbum.length);
//     };

//     // Filtering Logic
//     const filteredProjects = activeCategory === 'All'
//         ? projectsData
//         : projectsData.filter(project => project.category === activeCategory);

//     const theme = {
//         background: '#FFFFFF',
//         surface: '#F8F6F2',
//         accent: '#D4AF37',
//         textMain: '#2C302E',
//         textMuted: '#7A827E',
//         border: 'rgba(44, 48, 46, 0.08)'
//     };

//     // Advanced Mobile Layout CSS Injections
//     const inlineAnimations = `
//     @keyframes scaleUpIn {
//       from { opacity: 0; transform: scale(0.92) translateY(30px); }
//       to { opacity: 1; transform: scale(1) translateY(0); }
//     }
//     .animate-portfolio-grid {
//       animation: scaleUpIn 0.8s cubic-bezier(0.16, 1, 0.3, 1) forwards;
//     }

//     /* ==================== SCREEN RESPONSIVE LAYOUT BREAKPOINTS ==================== */
//     @media (max-width: 768px) {
//         .projects-screen-container { padding: 30px 20px !important; }
//         .projects-header-block { flex-direction: column !important; align-items: flex-start !important; gap: 20px !important; margin-bottom: 30px !important; }
//         .projects-main-title { font-size: 2.2rem !important; }

//         /* Converts Filter container into horizontally scrollable strip on mobile */
//         .filter-pill-container { 
//             width: 100% !important; 
//             overflow-x: auto !important; 
//             white-space: nowrap !important; 
//             padding: 8px !important;
//             justify-content: flex-start !important;
//             scrollbar-width: none; /* Firefox */
//         }
//         .filter-pill-container::-webkit-scrollbar { display: none; } /* Chrome/Safari */

//         /* Forces Asymmetric grid spans into clean uniform rows on mobile phone viewports */
//         .portfolio-responsive-grid { 
//             grid-template-columns: 1fr !important; 
//             grid-auto-rows: 280px !important; 
//             gap: 20px !important; 
//         }
//         .grid-span-override { grid-column: span 1 !important; grid-row: span 1 !important; }

//         /* Lightbox Layout Compression */
//         .lightbox-modal-core { gap: 15px !important; width: 95vw !important; }
//         .lightbox-arrow-btn { width: 44px !important; height: 44px !important; font-size: 1.2rem !important; }
//         .lightbox-media-frame { maxWidth: 90vw !important; maxHeight: 60vh !important; }
//         .lightbox-info-header { top: 20px !important; left: 20px !important; }
//         .lightbox-close-node { top: 15px !important; right: 20px !important; }
//     }
//   `;

//     return (
//         <div className="projects-screen-container" style={{
//             background: theme.background,
//             minHeight: '100vh',
//             color: theme.textMain,
//             padding: '40px 60px',
//             fontFamily: 'system-ui, -apple-system, sans-serif',
//             boxSizing: 'border-box',
//             transition: 'background 0.5s ease'
//         }}>
//             <style>{inlineAnimations}</style>

//             {/* Navigation Return Hook */}
//             {/* <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '30px' }}>
//                 <Link
//                     to="/"
//                     style={{ color: theme.textMuted, textDecoration: 'none', fontSize: '0.9rem', letterSpacing: '1px', transition: 'color 0.2s' }}
//                     onMouseEnter={(e) => e.target.style.color = theme.accent}
//                     onMouseLeave={(e) => e.target.style.color = theme.textMuted}
//                 >
//                     ← Back To Main Screen
//                 </Link>
//                 <span style={{ fontSize: '0.8rem', color: theme.textMuted, letterSpacing: '2px', textTransform: 'uppercase' }}>
//                     ST Interior Studio
//                 </span>
//             </div> */}

//             {/* ==================== SCREEN TITLE & DYNAMIC FILTER BAR ==================== */}
//             <div className="projects-header-block" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', flexWrap: 'wrap', gap: '30px', marginBottom: '50px' }}>
//                 <div>
//                     <span style={{ color: theme.accent, textTransform: 'uppercase', letterSpacing: '4px', fontSize: '0.85rem', fontWeight: '600' }}>Exquisite Spaces</span>
//                     <h1 className="projects-main-title" style={{ fontSize: '3.2rem', fontWeight: '300', margin: '5px 0 0 0', letterSpacing: '1px', color: theme.textMain }}>Featured Projects</h1>
//                 </div>

//                 {/* Filter Pill Architecture Container */}
//                 <div className="filter-pill-container" style={{ display: 'flex', gap: '12px', background: theme.surface, padding: '6px', borderRadius: '40px', border: `1px solid ${theme.border}`, boxShadow: '0 4px 10px rgba(0,0,0,0.02)' }}>
//                     {categories.map((cat) => {
//                         const isSelected = activeCategory === cat;
//                         return (
//                             <button
//                                 key={cat}
//                                 onClick={() => setActiveCategory(cat)}
//                                 style={{
//                                     background: isSelected ? theme.accent : 'transparent',
//                                     color: isSelected ? '#FFFFFF' : theme.textMain,
//                                     border: 'none',
//                                     padding: '10px 24px',
//                                     borderRadius: '30px',
//                                     fontSize: '0.9rem',
//                                     fontWeight: '600',
//                                     cursor: 'pointer',
//                                     transition: 'all 0.4s cubic-bezier(0.16, 1, 0.3, 1)',
//                                     letterSpacing: '0.5px',
//                                     display: 'inline-block'
//                                 }}
//                             >
//                                 {cat}
//                             </button>
//                         );
//                     })}
//                 </div>
//             </div>

//             {/* ==================== ASYMMETRIC LUXURY GRID SYSTEM ==================== */}
//             <div className="animate-portfolio-grid portfolio-responsive-grid"
//                 style={{
//                     display: 'grid',
//                     gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))',
//                     gridAutoRows: '260px',
//                     gap: '30px',
//                     gridAutoFlow: 'dense'
//                 }}>
//                 {filteredProjects.map((project) => {
//                     const isCardHovered = hoveredCard === project.id;

//                     let gridStyle = {};
//                     if (project.gridSpan === 'large') gridStyle = { gridColumn: 'span 2', gridRow: 'span 2' };
//                     if (project.gridSpan === 'tall') gridStyle = { gridRow: 'span 2' };

//                     return (
//                         <div
//                             key={project.id}
//                             className="grid-span-override"
//                             onClick={() => openAlbum(project)}
//                             onMouseEnter={() => setHoveredCard(project.id)}
//                             onMouseLeave={() => setHoveredCard(null)}
//                             style={{
//                                 ...gridStyle,
//                                 position: 'relative',
//                                 borderRadius: '20px',
//                                 overflow: 'hidden',
//                                 background: theme.surface,
//                                 border: `1px solid ${theme.border}`,
//                                 cursor: 'pointer',
//                                 boxShadow: isCardHovered ? '0 15px 35px rgba(44, 48, 46, 0.08)' : 'none',
//                                 transform: isCardHovered ? 'translateY(-6px)' : 'translateY(0)',
//                                 transition: 'all 0.5s cubic-bezier(0.16, 1, 0.3, 1)'
//                             }}
//                         >
//                             {/* Render block checking for Local Video vs Images inside Grid Cover Layer */}
//                             {project.type === 'video' ? (
//                                 <video
//                                     autoPlay
//                                     loop
//                                     muted
//                                     playsInline
//                                     style={{
//                                         width: '100%',
//                                         height: '100%',
//                                         objectFit: 'cover',
//                                         opacity: isCardHovered ? 0.85 : 0.95,
//                                         transform: isCardHovered ? 'scale(1.04)' : 'scale(1)',
//                                         transition: 'all 0.6s cubic-bezier(0.16, 1, 0.3, 1)'
//                                     }}
//                                 >
//                                     <source src={project.img} type="video/mp4" />
//                                 </video>
//                             ) : (
//                                 <img
//                                     src={project.img}
//                                     alt={project.title}
//                                     style={{
//                                         width: '100%',
//                                         height: '100%',
//                                         objectFit: 'cover',
//                                         opacity: isCardHovered ? 0.85 : 0.95,
//                                         transform: isCardHovered ? 'scale(1.04)' : 'scale(1)',
//                                         transition: 'all 0.6s cubic-bezier(0.16, 1, 0.3, 1)'
//                                     }}
//                                 />
//                             )}

//                             {/* Soft Gradient Overlay */}
//                             <div style={{
//                                 position: 'absolute',
//                                 top: 0,
//                                 left: 0,
//                                 width: '100%',
//                                 height: '100%',
//                                 // background: 'linear-gradient(to top, rgba(248, 246, 242, 0.95) 0%, rgba(248, 246, 242, 0.1) 60%)',
//                                 zIndex: 2,
//                                 opacity: isCardHovered ? 0.9 : 0.8,
//                                 transition: 'opacity 0.4s ease'
//                             }} />

//                             {/* Text Content Overlay Layer */}
//                             <div style={{
//                                 position: 'absolute',
//                                 bottom: 0,
//                                 left: 0,
//                                 width: '100%',
//                                 padding: '30px',
//                                 boxSizing: 'border-box',
//                                 zIndex: 3,
//                                 transform: isCardHovered ? 'translateY(-4px)' : 'translateY(0)',
//                                 transition: 'transform 0.4s cubic-bezier(0.16, 1, 0.3, 1)'
//                             }}>
//                                 <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
//                                     <span style={{
//                                         fontSize: '0.75rem',
//                                         color: theme.accent,
//                                         textTransform: 'uppercase',
//                                         letterSpacing: '2px',
//                                         fontWeight: '600'
//                                     }}>
//                                         {project.category}
//                                     </span>
//                                     {project.size && (
//                                         <span style={{ fontSize: '0.8rem', color: theme.textMuted }}>
//                                             {project.size}
//                                         </span>
//                                     )}
//                                 </div>

//                                 <h3 style={{
//                                     margin: '0',
//                                     fontSize: '1.3rem',
//                                     fontWeight: '400',
//                                     letterSpacing: '0.5px',
//                                     // color: theme.textMain
//                                     color:'white'
//                                 }}>
//                                     {project.title}
//                                 </h3>

//                                 <div style={{
//                                     height: '2px',
//                                     background: theme.accent,
//                                     marginTop: '12px',
//                                     width: isCardHovered ? '100%' : '0%',
//                                     transition: 'width 0.4s ease'
//                                 }} />
//                             </div>
//                         </div>
//                     );
//                 })}
//             </div>

//             {/* ==================== INTERACTIVE IMAGE ALBUM LIGHTBOX POPUP ==================== */}
//             {lightboxOpen && (
//                 <div 
//                     onClick={() => setLightboxOpen(false)}
//                     style={{
//                         position: 'fixed',
//                         top: 0,
//                         left: 0,
//                         width: '100vw',
//                         height: '100vh',
//                         background: 'rgba(26, 28, 27, 0.96)', 
//                         zIndex: 100,
//                         display: 'flex',
//                         flexDirection: 'column',
//                         justifyContent: 'center',
//                         alignItems: 'center',
//                         backdropFilter: 'blur(10px)'
//                     }}
//                 >
//                     {/* Album Info Headers */}
//                     <div className="lightbox-info-header" style={{ position: 'absolute', top: '30px', left: '40px', color: '#FFF', zIndex: 110 }}>
//                         <h4 style={{ margin: 0, fontSize: '1.4rem', fontWeight: 300, letterSpacing: '1px' }}>{activeTitle}</h4>
//                         <p style={{ margin: '5px 0 0 0', fontSize: '0.85rem', color: '#AAA' }}>Image {currentImgIdx + 1} of {currentAlbum.length}</p>
//                     </div>

//                     {/* Exit Button */}
//                     <button 
//                         className="lightbox-close-node"
//                         onClick={() => setLightboxOpen(false)}
//                         style={{
//                             position: 'absolute',
//                             top: '30px',
//                             right: '40px',
//                             background: 'none',
//                             border: 'none',
//                             color: '#FFF',
//                             fontSize: '2rem',
//                             cursor: 'pointer',
//                             opacity: 0.7,
//                             transition: 'opacity 0.2s',
//                             zIndex: 110
//                         }}
//                     >
//                         ✕
//                     </button>

//                     {/* Main Image Slider Node Container */}
//                     <div className="lightbox-modal-core" style={{ display: 'flex', alignItems: 'center', gap: '40px', width: '85vw', justifyContent: 'space-between', position: 'relative' }}>

//                         {/* LEFT ARROW */}
//                         <button 
//                             className="lightbox-arrow-btn"
//                             onClick={prevImage}
//                             style={{
//                                 background: 'rgba(255,255,255,0.04)',
//                                 border: '1px solid rgba(255,255,255,0.1)',
//                                 color: '#FFF',
//                                 width: '60px',
//                                 height: '60px',
//                                 borderRadius: '50%',
//                                 fontSize: '1.5rem',
//                                 cursor: 'pointer',
//                                 transition: 'all 0.2s',
//                                 flexShrink: 0
//                             }}
//                         >
//                             ‹
//                         </button>

//                         {/* CORE VISUAL CONTENT TANK ELEMENT */}
//                         <div className="lightbox-media-frame" style={{
//                             maxWidth: '70vw',
//                             maxHeight: '75vh',
//                             borderRadius: '12px',
//                             overflow: 'hidden',
//                             boxShadow: '0 30px 60px rgba(0,0,0,0.5)',
//                             background: '#000',
//                             display: 'flex',
//                             alignItems: 'center'
//                         }}>
//                             {/* Autoplay & Re-mounting execution hook based on file extension checks */}
//                             {currentAlbum[currentImgIdx]?.endsWith('.mp4') || currentAlbum[currentImgIdx] === dt1 ? (
//                                 <video
//                                     key={currentImgIdx}
//                                     autoPlay
//                                     controls
//                                     loop
//                                     muted
//                                     playsInline
//                                     onClick={(e) => e.stopPropagation()}
//                                     style={{
//                                         width: '100%',
//                                         maxHeight: '75vh',
//                                         objectFit: 'contain'
//                                     }}
//                                 >
//                                     <source src={currentAlbum[currentImgIdx]} type="video/mp4" />
//                                 </video>
//                             ) : (
//                                 <img 
//                                     src={currentAlbum[currentImgIdx]} 
//                                     alt="Studio Portfolio Workspace Asset"
//                                     onClick={(e) => e.stopPropagation()} 
//                                     style={{
//                                         maxWidth: '100%',
//                                         maxHeight: '75vh',
//                                         objectFit: 'contain',
//                                         animation: 'scaleUpIn 0.4s ease-out'
//                                     }}
//                                 />
//                             )}
//                         </div>

//                         {/* RIGHT ARROW */}
//                         <button 
//                             className="lightbox-arrow-btn"
//                             onClick={nextImage}
//                             style={{
//                                 background: 'rgba(255,255,255,0.04)',
//                                 border: '1px solid rgba(255,255,255,0.1)',
//                                 color: '#FFF',
//                                 width: '60px',
//                                 height: '60px',
//                                 borderRadius: '50%',
//                                 fontSize: '1.5rem',
//                                 cursor: 'pointer',
//                                 transition: 'all 0.2s',
//                                 flexShrink: 0
//                             }}
//                         >
//                             ›
//                         </button>
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// };

// export default Projects;

// import React, { useState, useEffect, useRef } from 'react';

// const PROJECTS_DATA = [
//     {
//         id: 1,
//         title: 'The Crisp Living',
//         category: 'Residential',
//         location: 'Mumbai',
//         image: 'https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?auto=format&fit=crop&w=800&q=80',
//         gallery: [
//             'https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?auto=format&fit=crop&w=800&q=80',
//             'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=800&q=80',
//             'https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?auto=format&fit=crop&w=800&q=80',
//             'https://images.unsplash.com/photo-1617806118233-18e1db207f62?auto=format&fit=crop&w=800&q=80',
//             'https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?auto=format&fit=crop&w=800&q=80',
//             'https://images.unsplash.com/photo-1556912172-45b7abe8b7e1?auto=format&fit=crop&w=800&q=80'
//         ],
//         description: 'A thoughtful architectural project balance combining raw texturing metrics with functional sleek lines. Strategically designed to allow natural lumens to interact beautifully with customized timber implementations across all central living blocks.'
//     },
//     {
//         id: 2,
//         title: 'Minimalist Haven',
//         category: 'Residential',
//         location: 'Pune',
//         image: 'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=800&q=80',
//         gallery: [
//             'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=800&q=80',
//             'https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?auto=format&fit=crop&w=800&q=80',
//             'https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?auto=format&fit=crop&w=800&q=80'
//         ],
//         description: 'Stripping back internal visual noise to generate absolute tranquility. Features custom low-profile seating layouts and curated stone surfaces.'
//     }
// ];

// // Smooth entry scroll reveal animation hook
// const useScrollReveal = () => {
//     const elementRef = useRef(null);
//     useEffect(() => {
//         const observer = new IntersectionObserver(
//             ([entry]) => {
//                 if (entry.isIntersecting) {
//                     entry.target.classList.add('revealed');
//                 }
//             },
//             { threshold: 0.02, rootMargin: '0px 0px -20px 0px' }
//         );
//         if (elementRef.current) observer.observe(elementRef.current);
//         return () => observer.disconnect();
//     }, []);
//     return elementRef;
// };

// // Main Grid List Card Component with Fixed CSS Parallax Layering
// const ProjectCard = ({ project, onViewProject }) => {
//     const revealRef = useScrollReveal();

//     return (
//         <div ref={revealRef} className="project-row-card reveal-hidden">
//             {/* Fail-safe Parallax Window Container */}
//             <div className="project-parallax-container">
//                 <div
//                     className="project-fixed-bg"
//                     style={{
//                         backgroundImage: `url(${project.image})`,
//                         backgroundSize: 'cover',
//                         backgroundPosition: 'center',
//                         backgroundAttachment: 'fixed',
//                         height: '100%',
//                         width: '100%',
//                     }}
//                 />
//             </div>

//             {/* Right Side Info Box Frame */}
//             <div className="project-info-panel">
//                 <div className="info-content-holder">
//                     <h2 className="project-card-title">{project.title}</h2>
//                     <p className="project-card-meta">{project.category} • {project.location}</p>

//                     {/* Exact Theme Match Button Layer */}
//                     <button
//                         // onClick={() => scrollToSectionId('projects')}
//                         style={{
//                             padding: '14px 40px',
//                             fontSize: '1rem',
//                             fontWeight: '600',
//                             color: '#FFFFFF',
//                             backgroundColor: '#2C302E',
//                             border: 'none',
//                             // borderRadius: '30px',
//                             cursor: 'pointer',
//                             boxShadow: '0 4px 20px rgba(0,0,0,0.25)',
//                             transition: 'all 0.3s ease',
//                             outline: 'none'
//                         }}
//                         onMouseEnter={(e) => {
//                             e.target.style.transform = 'translateY(-3px)';
//                             e.target.style.backgroundColor = '#D4AF37';
//                             e.target.style.boxShadow = '0 8px 25px rgba(0,0,0,0.35)';
//                         }}
//                         onMouseLeave={(e) => {
//                             e.target.style.transform = 'translateY(0)';
//                             e.target.style.backgroundColor = '#2C302E';
//                             e.target.style.boxShadow = '0 4px 20px rgba(0,0,0,0.25)';
//                         }}
//                     >
//                         Explore Projects
//                     </button>
//                 </div>
//             </div>
//         </div>
//     );
// };

// // Full Project Sub-gallery screen
// const ProjectGalleryView = ({ project, onBack }) => {
//     return (
//         <div className="gallery-view-root">
//             <div className="gallery-navigation-bar">
//                 <button className="back-to-portfolio-btn" onClick={onBack}>
//                     ← Back to Projects
//                 </button>
//                 <div className="gallery-header-meta">
//                     <h1 className="gallery-main-title">{project.title}</h1>
//                     <p className="gallery-subtitle-tag">{project.category} — {project.location}</p>
//                 </div>
//             </div>

//             {/* Asymmetric Presentation Layout stream matching reference images */}
//             <div className="gallery-images-masonry">
//                 {project.gallery?.map((imgUrl, i) => {
//                     const itemClass = i % 3 === 0 ? 'span-double' : 'span-single';
//                     return (
//                         <div key={i} className={`gallery-image-frame ${itemClass}`}>
//                             <img src={imgUrl} alt="Interior context clip" loading="lazy" />
//                         </div>
//                     );
//                 })}
//             </div>

//             {/* Description Card & Sticky Back Control Footer Layout */}
//             <section className="gallery-briefing-footer">
//                 <div className="briefing-inner-box">
//                     <p className="briefing-narrative-paragraph">{project.description}</p>
//                     <div className="brief-divider-line" />
//                     <button
//                         className="theme-explore-btn"
//                         onClick={onBack}
//                         style={{
//                             padding: '14px 40px',
//                             fontSize: '1rem',
//                             fontWeight: '600',
//                             color: '#FFFFFF',
//                             backgroundColor: '#2C302E',
//                             border: 'none',
//                             borderRadius: '30px',
//                             cursor: 'pointer',
//                             boxShadow: '0 4px 20px rgba(0, 0, 0, 0.25)',
//                             transition: 'all 0.2s ease'
//                         }}
//                     >
//                         Return to Main Portfolio
//                     </button>
//                 </div>
//             </section>
//         </div>
//     );
// };

// // Global Routing Application Controller
// const Projects = () => {
//     const [activeProject, setActiveProject] = useState(null);

//     const handleSwitchScreen = (project) => {
//         setActiveProject(project);
//         // Force the viewport directly to the absolute top coordinates instantly
//         window.scrollTo(0, 0);
//     };

//     return (
//         <div id="projects" className="projects-page-container">
//             <style>{`
//                 .projects-page-container {
//                     background-color: #FFFFFF;
//                     font-family: 'system-ui', -apple-system, sans-serif;
//                     color: #2C302E;
//                     overflow-x: hidden;
//                 }

//                 .projects-hero-view {
//                     text-align: center;
//                     padding: 80px 20px 40px 20px;
//                     background: #FDFDFD;
//                 }
//                 .main-view-title {
//                     font-size: 2.8rem;
//                     font-weight: 300;
//                     letter-spacing: 4px;
//                     text-transform: uppercase;
//                     margin: 0;
//                     color: #2C302E;
//                 }

//                 /* ==================== INDEX PAGE CARDS ==================== */
//                 .projects-list-deck {
//                     max-width: 1200px;
//                     margin: 0 auto;
//                     padding: 0 4% 100px 4%;
//                     display: flex;
//                     flex-direction: column;
//                     gap: 60px;
//                 }
//                 .project-row-card {
//                     display: flex;
//                     flex-direction: row; 
//                     height: 460px;
//                     background: #FDFDFD;
//                     overflow: hidden;
//                     border: 1px solid #EFEFEF;
//                     box-shadow: 0 10px 30px rgba(0,0,0,0.015);
//                 }

//                 /* Fixed Parallax Container Engine - Bypasses transform scaling blocks */
//                 .project-parallax-container {
//                     flex: 1.2;
//                     position: relative;
//                     overflow: hidden;
//                     clip-path: inset(0 0 0 0); /* Forces fixed children bounds to layer locally */
//                 }
//                 .project-fixed-bg {
//                     position: fixed;
//                     top: 0;
//                     left: 0;
//                     width: 100%;
//                     height: 100%;
//                     background-size: cover;
//                     background-position: center;
//                     background-repeat: no-repeat;
//                     pointer-events: none;
//                 }

//                 /* Info Panel Frame */
//                 .project-info-panel {
//                     flex: 1; 
//                     background: #FFFFFF; 
//                     display: flex; 
//                     align-items: center; 
//                     justify-content: center; 
//                     padding: 40px; 
//                     box-sizing: border-box;
//                     z-index: 2;
//                 }
//                 .info-content-holder { width: 85%; text-align: center; }
//                 .project-card-title { font-size: 1.75rem; font-weight: 400; margin: 0 0 8px 0; letter-spacing: 0.5px; }
//                 .project-card-meta { font-size: 0.9rem; color: #7A807E; margin: 0 0 35px 0; text-transform: uppercase; letter-spacing: 1px; }

//                 /* Interactivity Physics Engine for Action Links */
//                 .theme-explore-btn:hover {
//                     transform: scale(1.03);
//                     background-color: #202322 !important;
//                 }

//                 /* ==================== INNER SPECIFIC PORTFOLIO VIEW SCREEN ==================== */
//                 .gallery-view-root {
//                     max-width: 1300px;
//                     margin: 0 auto;
//                     padding: 40px 4% 100px 4%;
//                     animation: screenFadeIn 0.5s cubic-bezier(0.16, 1, 0.3, 1) forwards;
//                 }
//                 @keyframes screenFadeIn {
//                     from { opacity: 0; transform: translateY(15px); }
//                     to { opacity: 1; transform: translateY(0); }
//                 }
//                 .gallery-navigation-bar {
//                     display: flex;
//                     flex-direction: column;
//                     align-items: flex-start;
//                     margin-bottom: 50px;
//                     gap: 20px;
//                 }
//                 .back-to-portfolio-btn {
//                     background: none; border: none; font-size: 0.95rem; color: #7A807E;
//                     cursor: pointer; padding: 0; font-weight: 500; transition: color 0.2s;
//                 }
//                 .back-to-portfolio-btn:hover { color: #2C302E; }
//                 .gallery-header-meta { width: 100%; text-align: center; }
//                 .gallery-main-title { font-size: 2.6rem; font-weight: 300; text-transform: uppercase; margin: 0 0 6px 0; letter-spacing: 2px; }
//                 .gallery-subtitle-tag { font-size: 0.9rem; color: #7A807E; text-transform: uppercase; letter-spacing: 1.5px; }

//                 /* Matrix layout templates */
//                 .gallery-images-masonry {
//                     display: grid;
//                     grid-template-columns: repeat(2, 1fr);
//                     gap: 30px;
//                 }
//                 .gallery-image-frame { overflow: hidden; background-color: #FAF9F6; }
//                 .gallery-image-frame img { width: 100%; height: 100%; object-fit: cover; display: block; }

//                 .span-double { grid-column: span 2; height: 700px; }
//                 .span-single { grid-column: span 1; height: 490px; }

//                 .gallery-briefing-footer {
//                     margin-top: 90px; padding: 60px 0; display: flex; justify-content: center; background: #FAF9F6;
//                 }
//                 .briefing-inner-box { max-width: 750px; text-align: center; padding: 0 20px; }
//                 .briefing-narrative-paragraph { font-size: 1.05rem; line-height: 1.8; color: #4A504E; font-weight: 300; margin-bottom: 35px; }
//                 .brief-divider-line { width: 60px; height: 1px; background: #2C302E; margin: 0 auto 35px auto; opacity: 0.2; }

//                 /* Reveal animations configuration mapping */
//                 .reveal-hidden {
//                     opacity: 0; transform: translateY(30px);
//                     transition: opacity 0.8s cubic-bezier(0.16, 1, 0.3, 1), transform 0.8s cubic-bezier(0.16, 1, 0.3, 1);
//                 }
//                 .reveal-hidden.revealed { opacity: 1; transform: translateY(0); }

//                 /* ==================== SCREEN RESPONSIVE MEDIA ASSIGNMENTS ==================== */
//                 @media (max-width: 991px) {
//                     .project-row-card { flex-direction: column !important; height: auto; }
//                     .project-parallax-container { height: 320px; width: 100%; }
//                     .project-fixed-bg { 
//                        background-size: cover;
//     background-position: center;
//     background-repeat: no-repeat;
//     background-attachment: fixed;

//                     }
//                     .project-info-panel { padding: 45px 20px; }
//                     .span-double, .span-single { grid-column: span 2 !important; height: 400px; }
//                     .gallery-main-title { font-size: 2.1rem; }
//                 }
//                 @media (max-width: 575px) {
//                     .project-parallax-container { height: 250px; }
//                     .project-card-title { font-size: 1.4rem; }
//                     .span-double, .span-single { height: 290px; }
//                 }
//             `}</style>

//             {/* Dynamic Content Core Router */}
//             {!activeProject ? (
//                 <>
//                     <section className="projects-hero-view">
//                         <h1 className="main-view-title">Projects</h1>
//                     </section>
//                     <main className="projects-list-deck">
//                         {PROJECTS_DATA.map((project) => (
//                             <ProjectCard
//                                 key={project.id}
//                                 project={project}
//                                 onViewProject={handleSwitchScreen}
//                             />
//                         ))}
//                     </main>
//                 </>
//             ) : (
//                 <ProjectGalleryView
//                     project={activeProject}
//                     onBack={() => handleSwitchScreen(null)}
//                 />
//             )}
//         </div>
//     );
// };

// export default Projects;


import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

import project1main from '../Assets/Project1/Untitled-2.png'
import pg1 from '../Assets/Project1/Untitled-2.png'
import pg2 from '../Assets/Project1/pg2.jpg'
import pg3 from '../Assets/Project1/Untitled-10.png'
import pg4 from '../Assets/Project1/Untitled-9.png'
import pg5 from '../Assets/Project1/Untitled-7.png'
import pg6 from '../Assets/Project1/Untitled-8.png'

import project2main from '../Assets/Project2/07104main.jpg'
import p2g1 from '../Assets/Project2/07113.jpg'
import p2g2 from '../Assets/Project2/07137.jpg'
import p2g3 from '../Assets/Project2/07080.jpg'
import p2g4 from '../Assets/Project2/5318.jpg'
import p2g5 from '../Assets/Project2/5328.jpg'
import p2g6 from '../Assets/Project2/5332.jpg'
import p2g7 from '../Assets/Project2/06972.jpg'
import p2g8 from '../Assets/Project2/07005.jpg'
import p2g9 from '../Assets/Project2/07023.jpg'
import p2g10 from '../Assets/Project2/07026.jpg'
import p2g11 from '../Assets/Project2/07050.jpg'
import p2g12 from '../Assets/Project2/07180.jpg'
import p2g13 from '../Assets/Project2/07186.jpg'
import p2g14 from '../Assets/Project2/07189.jpg'
import p2g15 from '../Assets/Project2/07195.jpg'
import p2g16 from '../Assets/Project2/07222.jpg'
import p2g17 from '../Assets/Project2/07234.jpg'
import p2g18 from '../Assets/Project2/IMG_5377.jpg'


import project3main from '../Assets/Project3/MAIN.jpg'
import p3g1 from '../Assets/Project3/IMG_7560.jpg'
import p3g2 from '../Assets/Project3/IMG_7566.jpg'
import p3g3 from '../Assets/Project3/IMG_7599.jpg'
import p3g4 from '../Assets/Project3/IMG_7609.jpg'
import p3g5 from '../Assets/Project3/IMG_7635.jpg'
import p3g6 from '../Assets/Project3/IMG_7656.jpg'
import p3g7 from '../Assets/Project3/IMG_7668.jpg'
import p3g8 from '../Assets/Project3/IMG_7677.jpg'
import p3g9 from '../Assets/Project3/IMG_7701.jpg'
import p3g10 from '../Assets/Project3/IMG_7713.jpg'
import p3g11 from '../Assets/Project3/IMG_7716.jpg'
import p3g12 from '../Assets/Project3/IMG_7719.jpg'


import project4main from '../Assets/Project4/03703.jpg'
import p4g1 from '../Assets/Project4/03769.jpg'
import p4g2 from '../Assets/Project4/03745.jpg'
import p4g3 from '../Assets/Project4/03757.jpg'
import p4g4 from '../Assets/Project4/03781.jpg'
import p4g5 from '../Assets/Project4/03748.jpg'
import p4g6 from '../Assets/Project4/03793.jpg'
import p4g7 from '../Assets/Project4/03778.jpg'
import p4g8 from '../Assets/Project4/03784.jpg'
import p4g9 from '../Assets/Project4/03823.jpg'
import p4g10 from '../Assets/Project4/03805.jpg'
import p4g11 from '../Assets/Project4/03811.jpg'
import p4g12 from '../Assets/Project4/03814.jpg'
import p4g13 from '../Assets/Project4/03637.jpg'
import p4g14 from '../Assets/Project4/03646.jpg'
import p4g15 from '../Assets/Project4/03652.jpg'
import p4g16 from '../Assets/Project4/03661.jpg'
import p4g17 from '../Assets/Project4/03667.jpg'
import p4g18 from '../Assets/Project4/03673.jpg'
import p4g19 from '../Assets/Project4/03679.jpg'
import p4g20 from '../Assets/Project4/03721.jpg'
import p4g21 from '../Assets/Project4/03724.jpg'
import p4g22 from '../Assets/Project4/03727.jpg'
import p4g23 from '../Assets/Project4/03730.jpg'
import p4g24 from '../Assets/Project4/03733.jpg'
import p4g25 from '../Assets/Project4/03847.jpg'
import p4g26 from '../Assets/Project4/03838.jpg'
import p4g27 from '../Assets/Project4/03835.jpg'
import p4g28 from '../Assets/Project4/03841.jpg'
import p4g29 from '../Assets/Project4/03826.jpg'
import p4g30 from '../Assets/Project4/03853.jpg'





// const project1Gallery = [pg1, pg2, pg3];
// Full data mapping containing the specific nested image lists
const PROJECTS_DATA = [
    {
        id: 1,
        title: 'Atelier Elan',
        category: 'Commercial',
        location: 'Baner, Pune',
        image: project1main,
        gallery: [
            pg1,
            pg2,
            pg3,
            pg4,
            pg5,
            pg6,
        ],
        description: 'A modern corporate workspace designed to reflect professionalism, collaboration, and global connectivity. Clean lines, warm wood finishes, glass-enclosed meeting rooms, and biophilic elements create a productive yet welcoming environment. Thoughtfully planned workstations and refined branding details establish a workplace that balances efficiency, comfort, and contemporary elegance.',
        clientName: 'Gaurav Joshi, CEO',
        clientReview: 'The team completely transformed our workspace layout. The balance between private glass offices and collaborative biophilic zones has skyrocketed our productivity.',
    },
    {
        id: 2,
        // title: 'Minimalist Haven',
        title: 'Casa Yugen',
        category: 'Residential',
        location: 'Bhugaon,Pune',
        image: project2main,
        gallery: [project2main, p2g1, p2g2, p2g3, p2g4, p2g5, p2g6, p2g7, p2g8, p2g9, p2g10, p2g11, p2g12, p2g13, p2g15, p2g14, p2g17, p2g16, p2g18,],
        description: 'A thoughtfully crafted residence blending contemporary elegance with warm natural textures. Soft lighting, curved detailing, bespoke wooden elements, and a refined neutral palette create a welcoming atmosphere that feels both luxurious and timeless. Every space, from the inviting living area to the sleek modular kitchen and serene private rooms, is designed to enhance comfort, functionality, and everyday living.',
        clientName: 'Mr and Mrs Raut ',
        clientReview: 'We love our new home! The transition between the indoor and outdoor deck is seamless.',
    },
    {
        id: 3,
        title: 'Atelier Azure',
        category: 'Commercial',
        location: 'Pune',
        image: project3main,
        gallery: [project3main, p3g2, p3g1, p3g3, p3g4, p3g5, p3g6, p3g7, p3g8, p3g9, p3g10, p3g11, p3g12,],
        description: 'A contemporary workspace designed to foster focus, collaboration, and seamless movement. Soft neutral tones, warm wood accents, curved architectural details, and transparent glass partitions create an environment that feels both professional and inviting. The design balances functionality with sophistication, maximizing natural light and visual openness throughout the office.',
        clientName: 'Mr kalpesh Hiwase',
        clientReview: 'Designing our living room with ST Studio was an absolute pleasure. Their pastel color management completely breathed new life into our home space.',
    },
    {
        id: 4,
        title: 'Casa Aura',
        category: 'Residential',
        location: 'Pune',
        image: project4main,
        gallery: [
            project4main,
            p4g1,
            p4g2,
            p4g3,
            p4g4,
            p4g5,
            p4g6,
            p4g7,
            p4g8,
            p4g9,
            p4g10,
            p4g11,
            p4g12,
            p4g13,
            p4g14,
            p4g15,
            p4g16,
            p4g17,
            p4g18,
            p4g19,
            p4g20,
            p4g21,
            p4g22,
            p4g23,
            p4g24,
            p4g25,
            p4g26,
            p4g27,
            p4g28,
            p4g29,
            p4g30
        ],
        description: 'A warm and elegant residence designed around natural light, soft neutral tones, and timeless wooden furnishings. Layered textures, custom wall detailing, and airy drapery create a serene atmosphere that balances comfort with refined sophistication. The open layout seamlessly connects living and dining spaces, delivering a welcoming home that feels both spacious and intimate.',
        clientName: 'Mr Kedar Bendre ',
        clientReview: 'We are thoroughly impressed by how they hid complex storage utility parameters inside clean, minimalist geometric foyer panels.',
    }
];

const ProjectCard = ({ project }) => {
    const cardRef = useRef(null);
    const navigate = useNavigate();
    const [isMobile, setIsMobile] = useState(window.innerWidth < 992);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 992);
        window.addEventListener('resize', handleResize);

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    entry.target.style.opacity = '1';
                    entry.target.style.transform = 'translateY(0)';
                }
            },
            { threshold: 0.05 }
        );
        if (cardRef.current) observer.observe(cardRef.current);

        return () => {
            window.removeEventListener('resize', handleResize);
            observer.disconnect();
        };
    }, []);

    const inlineStyles = {
        cardRow: {
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            minHeight: '460px',
            backgroundColor: '#FDFDFD',
            overflow: 'hidden',
            border: '1px solid #EFEFEF',
            boxShadow: '0 10px 30px rgba(0,0,0,0.015)',
            opacity: 0,
            transform: 'translateY(40px)',
            transition: 'opacity 0.8s cubic-bezier(0.16, 1, 0.3, 1), transform 0.8s cubic-bezier(0.16, 1, 0.3, 1)',
            marginBottom: '40px'
        },
        imageWrapper: {
            flex: '1.2',
            position: 'relative',
            overflow: 'hidden',
            minHeight: '320px'
        },
        parallaxBg: {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundImage: `url(${project.image})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundAttachment: isMobile ? 'scroll' : 'fixed'
        },
        infoPanel: {
            flex: '1',
            backgroundColor: '#FFFFFF',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '40px',
            boxSizing: 'border-box',
            zIndex: 2
        },
        contentHolder: {
            width: '85%',
            textAlign: 'center'
        },
        title: {
            fontSize: '1.75rem',
            fontWeight: '400',
            margin: '0 0 8px 0',
            letterSpacing: '0.5px',
            color: '#2C302E',
            fontFamily: "'Cinzel', Georgia, serif",
        },
        meta: {
            fontSize: '0.9rem',
            color: '#7A807E',
            margin: '0 0 35px 0',
            // textTransform: 'uppercase',
            letterSpacing: '1px',
             fontFamily: "'Cormorant Garamond', serif",

        },
        pillBtn: {
            padding: '14px 40px',
            fontSize: '1rem',
            fontWeight: '600',
            color: '#FFFFFF',
            backgroundColor: '#2C302E',
            border: 'none',
            borderRadius: '30px',
            cursor: 'pointer',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.25)',
            transition: 'all 0.2s ease',
            outline: 'none',
            textTransform: 'uppercase',
            letterSpacing: '1px',
            display: 'inline-block',
            fontFamily: "'Cinzel', Georgia, serif",
        }
    };

    return (
        <div ref={cardRef} style={inlineStyles.cardRow}>

            <div style={inlineStyles.imageWrapper}>
                <div style={inlineStyles.parallaxBg} />
            </div>
            <div style={inlineStyles.infoPanel}>
                <div style={inlineStyles.contentHolder}>
                    <h2 style={inlineStyles.title}>{project.title}</h2>
                    <p style={inlineStyles.meta}>{project.category} • {project.location}</p>
                    {/* <button
                        onClick={() => navigate(`/project/${project.id}`, { state: { project } })}
                        style={inlineStyles.pillBtn}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'scale(1.03)';
                            e.currentTarget.style.backgroundColor = '#D4AF37';
                            
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'scale(1)';
                            e.currentTarget.style.backgroundColor = '#2C302E';
                        }}
                    >
                        View Project
                    </button> */}

                    <button
                        onClick={() => navigate(`/project/${project.id}`, { state: { project } })}
                        style={{
                            ...inlineStyles.pillBtn,
                            backgroundColor: '#FFFFFF',
                            color: '#2C302E',
                            border: '1px solid rgba(44, 48, 46, 0.15)', // Subtle charcoal border
                            padding: '12px 28px',
                            borderRadius: '30px',
                            fontSize: '0.9rem',
                            fontWeight: '500',
                            letterSpacing: '1.5px',
                            textTransform: 'uppercase',
                            cursor: 'pointer',
                            transition: 'all 0.3s cubic-bezier(0.16, 1, 0.3, 1)',
                            outline: 'none'
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'scale(1.03)';
                            e.currentTarget.style.backgroundColor = '#D4AF37'; // Your signature gold accent
                            e.currentTarget.style.color = '#FFFFFF';
                            e.currentTarget.style.borderColor = '#D4AF37';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'scale(1)';
                            e.currentTarget.style.backgroundColor = '#FFFFFF'; // Returns back to clean white
                            e.currentTarget.style.color = '#2C302E';
                            e.currentTarget.style.borderColor = 'rgba(44, 48, 46, 0.15)';
                        }}
                    >
                        View Project
                    </button>
                </div>
            </div>
        </div>
    );
};

const Projects = () => {
    const globalStyles = {
        pageContainer: {
            backgroundColor: '#F8F6F2',
            // backgroundColor: '#FFFFFF',

            fontFamily: 'system-ui, -apple-system, sans-serif',
            color: '#2C302E',
            width: '100%',
           
        },
        heroView: {
            textAlign: 'center',
            padding: '80px 20px 40px 20px',
            background: '#F8F6F2'
        },
        mainTitle: {
            fontSize: '2.8rem',
            fontWeight: '300',
            letterSpacing: '4px',
            textTransform: 'uppercase',
            margin: 0
        },
        listDeck: {
            maxWidth: '1200px',
            margin: '0 auto',
            padding: '0 4% 100px 4%'
        }
    };
    const theme = {
        background: '#FFFFFF',
        accent: '#D4AF37',
        textMain: '#2C302E',
        textMuted: '#6E7270',
        border: 'rgba(44, 48, 46, 0.08)'
    };
    const responsiveStyles = `
        /* Dynamic import of the luxury Roman serif font */
        @import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@400;500;600&display=swap');

        @keyframes revealUp {
            from { opacity: 0; transform: translateY(50px); }
            to { opacity: 1; transform: translateY(0); }
        }
        .team-animate-entry { 
            animation: revealUp 1.2s cubic-bezier(0.16, 1, 0.3, 1) forwards; 
        }

        /* ==================== SCREEN RESPONSIVENESS ==================== */
        @media (max-width: 991px) {
            .team-grid-container {
                grid-template-columns: 1fr !important;
                gap: 50px !important;
                padding: 0 20px !important;
            }
            .team-card-wrapper {
                margin-top: 0 !important;
                transform: none !important;
            }
            .team-title-main {
                font-size: 2.2rem !important;
                letter-spacing: 4px !important;
            }
            .team-image-frame {
                height: 400px !important;
            }
        }
    `;
    return (
        <div id="projects" style={globalStyles.pageContainer}>

            <section className="team-animate-entry" style={{
                textAlign: 'center',
                marginBottom: '90px',
                padding: '0 20px',
                marginTop:"10%"
            }}>
                <span style={{
                    fontFamily: 'system-ui, -apple-system, sans-serif',
                    fontSize: '0.85rem',
                    fontWeight: '600',
                    textTransform: 'uppercase',
                    letterSpacing: '4px',
                    color: theme.accent, // Make sure you have your color theme imported or defined
                    display: 'block',
                    marginBottom: '12px'
                }}>
                    Selected Works
                </span>
                <h1 className="team-title-main" style={{
                    fontFamily: "'Cinzel', serif",
                    fontSize: 'calc(0.3rem + 1.5vw)',
                    fontWeight: '400',
                    textTransform: 'uppercase',
                    letterSpacing: '6px',
                    color: theme.textMain, // Matches your deep neutral tone
                    margin: 0
                }}>
                    Projects
                </h1>
                <div style={{
                    width: '60px',
                    height: '1px',
                    background: theme.accent,
                    margin: '24px auto 0 auto'
                }} />
            </section>
            <main style={globalStyles.listDeck}>
                {PROJECTS_DATA.map((project) => (
                    <ProjectCard key={project.id} project={project} />
                ))}
            </main>
        </div>
    );
};

export default Projects;